import script from "./AuthModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthModal.vue?vue&type=script&setup=true&lang=ts"

import "./AuthModal.vue?vue&type=style&index=0&id=cd279662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd279662"]])

export default __exports__